/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mLuckyItem.vue?vue&type=template&id=a429bf82&scoped=true"
import script from "./mLuckyItem.vue?vue&type=script&lang=js"
export * from "./mLuckyItem.vue?vue&type=script&lang=js"
import style0 from "./mLuckyItem.vue?vue&type=style&index=0&id=a429bf82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a429bf82",
  null
  
)

export default component.exports